import React, {Component, useEffect} from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import logo from './emclogo.png'; 
import flow from './flow.jpg'; 
import Iframe from 'react-iframe'

const styles = {
 
    card2: {
        alignItems:'center',
        align: 'center',
        boxShadow: 'none',
        border:'none',
        // height:'100%',
        // width:'100vw',
        // minHeight: 700,
        // minWidth: 725,
        marginLeft:'auto',
        marginRight: 'auto'
    },
    myClassname:{

    }
  };

class ChatBox extends Component {

    state={
        height:'30vh',
        width:'30vw'
    }

    componentWillMount(){
        this.setState({
            height:'30vh',
            width:'30vw'
        })
    }
    componentWillUnmount(){
        this.setState({
            height:'30vh',
            width:'30vw'
        })
    }

    componentDidMount() {
        try{
            var i = window.location.href;
            // console.log('iframe src: '+ JSON.stringify(i));
        }catch(err){
            console.log('iframe src err: '+err)
        }

        setInterval(()=>{

            var i = window.location.href;
            // console.log('interval i src: '+JSON.stringify(i))

            if(i == 'https://www.hkarbsoc.org.hk/chatbot.html'){
                console.log('interval src not opening.')
            }
            else{
                console.log('interval src opening.')
                // window.open(i,'_blank');
            }

        },1000)

        setInterval(()=>{
            this.setState({
                height:'100vh',
                width:'100vw'
            })
        },3000)
    }

    render(){
        const { classes, src } = this.props; 
        let fileURL = "";
        if (this.props.lang == "en"){
            fileURL = __dirname + 'chatbot.html'
        }
        else if (this.props.lang == "cn"){
            fileURL = __dirname + 'chatbot_chi.html'
        }

        // useEffect(() => {
        // const handler = event => {
        //     const data = JSON.parse(event.data)
        //     console.log("ChatBox message: " + JSON.stringify(data) )
        // }
        //     window.addEventListener("message", handler)
        //     // clean up
        //     return () => window.removeEventListener("message", handler)
        // }) // empty array => run only once
        
        return(
            <div style={{height:this.state.height, width:this.state.width}}>
                <Iframe url={fileURL}
                    id="myframe"
                    position="relative"
                    // width="60%"
                    // height="100%"
                    // height="100%"
                    className="myClassname"
                    />
            </div>
        );
    }
}

export default withStyles(styles)(ChatBox);